import React from "react"
import styled from "styled-components"
import Link from "gatsby-link"
import { below, above } from "../style/functions"
//import Svg from "../svg/map-new"
import Svg from "../svg/map-v6"
import * as vars from "../style/vars"

// output svg : style elements
// run through svgomg - move style to attributes
// convert xlink:href to xlinkHref

// Stored all map svg/png source files I could find are stored in [/static/images/map-source/].
// If you need the static img map source, grab it out of one of the PDFs (e.g. [/static/artisan-residences-brochure.pdf]).

class Masterplan extends React.Component {
	constructor() {
		super()
	}

	render() {
		return (
			<Contain >
				<img
					src="/images/map-v6-static.png"
					style={{
						width: "100%",
						objectFit: "cover"
					}} />
				<Svg />
			</Contain>
		)
	}
}

const Contain = styled.div`
	svg{
		display: block;
		margin-bottom: ${vars.padding.inner}rem;
		${below.mobile`
			display: none;
		`}
		.precinct{
			transition: opacity 0.5s ease-in-out;
			.popup{
				visibility: hidden;
				opacity: 0;
				transform: translateY(-15px);
				transition: opacity 0.5s ease-in-out,  visibility 0.5s ease-in-out, transform 0.7s ease-in-out;
			}
			&:hover{
				.popup{
						visibility: visible;
				opacity: 1;
				transform: translateX(0);
			}
				}

		}

		.point{
			.info{
				visibility: hidden;
				opacity: 0;
				transform: translateY(-15px);
				transition: opacity 0.5s ease-in-out,  visibility 0.5s ease-in-out, transform 0.7s ease-in-out;

			}
			.icon{
				cursor: pointer;
				&:hover{
					~.info{
						visibility: visible;
				opacity: 1;
				transform: translateX(0);
			}
				}
			}
		}
	}
	#buildings{
		.bg{
			transition: opacity 0.5s ease-in-out;
		}
	&:hover{
		.bg{
			opacity: 0.3;
		}
	}
	.precinct:hover .bg{
			opacity: 1;
		}
}
	img{
		display: none;
		margin-bottom: ${vars.padding.inner}rem;

		${below.mobile`
			display: block;
		`};
	}
`

export default Masterplan



// WEBPACK FOOTER //
// ./src/components/masterplan.js